export enum ContentType {
  Research = 'Research',
  News = 'News',
  Covenants = 'Covenants',
  Financials = 'Financials',
}
